module.exports = __webpack_public_path__ + "static/media/Inter-Regular.dfe4bd90.woff2";